// import Container from "../../../components/ui/Container"
// import { Tutti } from "../../../components/games/tutti/Tutti"
// import { useState } from "react"
// import { say } from "../../../helpers/speech"
// import { TuttiFruttiMsg } from "./TuttiFruttiMsg"

// const custom_say = (text) => {
//   const prompt=false, lang='es', rate=1.3
//   say(text, prompt, lang, rate)
// }

// const TuttiView = () => {

//   const [tuttiMsg, setTuttiMsg] = useState(false)

//   const tutti = (row) => {
//     custom_say('¡Tutti frutti!')
//     setTuttiMsg(true)
//     setTimeout(() => setTuttiMsg(false), 3000)
//   }

//   return <>
//     {tuttiMsg && <TuttiFruttiMsg />}

//     <Container>
//       <Tutti
//         tuttiMsg={tuttiMsg}
//         onTutti={tutti} />
//     </Container>
//   </>

// }

// export default TuttiView;

import Container from "../../../components/ui/Container.js"
import "../CrosswordView.scss"
import "../../../components/games/tutti/Tutti.scss"
import { useParams } from "react-router"
import { GamePicker } from "./GamePicker.js"

const TuttiView = () => {
  const { id } = useParams()

  return (
    <Container>
      {id ? (
        // ? <CrosswordsID id={id} />
        <GamePicker />
      ) : (
        <GamePicker />
      )}
    </Container>
  )
}

export default TuttiView
